import {
    DataHygieneStatus,
    StatusProps,
} from 'assets/js/pages/contacts/data-hygiene/DataHygieneStatus';
import { AddressDeliverabilityStatus } from 'types/domain';

interface AddressStatusProps {
    status: AddressDeliverabilityStatus;
}

const AddressStatus = ({ status }: AddressStatusProps) => {
    const statusMatch: StatusProps = getAddressStatusProps(status);

    if (!statusMatch) {
        return null;
    }

    return <DataHygieneStatus status={statusMatch} />;
};

const HELP_TEXT = {
    DELIVERABLE: `This address is deliverable and will reach the intended recipient.`,
    UNDELIVERABLE: `This address is not deliverable, which may be due to wrong information or the address not existing.`,
    CHANGE_OF_ADDRESS: `A change of address is initiated by the recipient when they have submitted a Notice of Change of Address to USPS.`,
    MISSING_INFO: `This address is deliverable but is missing additional details like a unit or suite number. There is a chance the mail will not reach the intended recipient.`,
    UNNECESSARY_UNIT: `This address is deliverable but some information is unnecessary.`,
    INCORRECT_UNIT: `This address is deliverable but some information is incorrect. There is a chance the mail will not reach the intended recipient.`,
};

const getAddressStatusProps = (status: AddressDeliverabilityStatus) => {
    switch (status) {
        case 'deliverable':
            return {
                displayText: 'Deliverable',
                dotColor: 'bg-green-500',
                tooltipText: HELP_TEXT.DELIVERABLE,
            };
        case 'deliverable_unnecessary_unit':
            return {
                displayText: 'Potential issue: Unnecessary information',
                dotColor: 'bg-orange-500',
                tooltipText: HELP_TEXT.UNNECESSARY_UNIT,
            };
        case 'deliverable_incorrect_unit':
            return {
                displayText: 'Potential issue: Incorrect information',
                dotColor: 'bg-orange-500',
                tooltipText: HELP_TEXT.INCORRECT_UNIT,
            };
        case 'deliverable_missing_unit': /* falls through */
        case 'deliverable_missing_info':
            return {
                displayText: 'Potential issue: Missing information',
                dotColor: 'bg-orange-500',
                tooltipText: HELP_TEXT.MISSING_INFO,
            };
        case 'undeliverable': /* falls through */
        case 'no_match': /* falls through */
        case 'invalid':
            return {
                displayText: 'Invalid address',
                dotColor: 'bg-red-500',
                tooltipText: HELP_TEXT.UNDELIVERABLE,
            };

        case 'change_of_address':
            return {
                displayText: 'Change of Address',
                dotColor: 'bg-brand-violet-primary',
                tooltipText: HELP_TEXT.CHANGE_OF_ADDRESS,
            };
    }
};

export { AddressStatus };
